<div class="container my-3">
  <!-- <h1 class="mb-3">Add Conductivity profile</h1> -->
  <form #form="ngForm" (ngSubmit)="addConductivityProfile()">
      <!-- Commented on 12th May 2026 for the breadcrumb changes -->
    <!-- <div class="col-6">
      <label for="name" class="form-label">Plant:</label>
      <select class="form-select border border-dark" name="plantid" (change)="getSelectedId($event)">
        <option [selected]>Select Plant</option>
        <option *ngFor="let plant of plants" [value]="plant.Id">
          {{ plant.Name }}
        </option>
      </select>
    </div> -->

    <!-- <div class="col-6">
      <label for="train" class="form-label">Train:</label>
      <select class="form-select border border-dark" name="trainid" (change)="getSelectedTrainId($event)">
        <option [selected]>Select Train</option>
        <option *ngFor="let train of trains" [value]="train.Id">
          {{ train.Name }}
        </option>
      </select>
    </div> -->

    <div class="col-6">
      <label for="Datetime" class="form-label">Datetime</label>
    </div>
    <div class="col-6">
      <input type="datetime-local" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}"
        class="form-control border border-dark" id="Datetime" name="Datetime" (change)="updateDatetime($event)" />
    </div>

    <div style="min-height: 20px;"></div>

    <div class="row" *ngIf="tableData">
      <div *ngIf="stage1PvIds.length != 0">
        <div class="row" style="font-weight: bold;">
          <div class="col-1">
            <label>Stage 1</label>
          </div>
          <div class="col-3">
            <label>Pressure Vessel ID:</label>
          </div>
          <div class="col-3">
            <label>Permeate Conductivity:</label>
          </div>
        </div>
        <div class="row" *ngFor="let row of stage1PvIds">
          <div class="col-1"></div>
          <div class="col-3">
            <div class="m-2">
              <input type="text" class="form-control border border-dark" name="{{ row }}" placeholder="{{ row }}"
                disabled="true" />
            </div>
          </div>
          <div class="col-3">
            <div class="m-2">
              <input type="text" id="permCond{{ row }}" name="permCond{{ row }}" [(ngModel)]="permCondValues[row]"
                class="form-control border border-dark" />
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="stage2PvIds.length != 0">
        <div class="row" style="font-weight: bold;">
          <div class="col-1"></div>
          <div class="col-1">
            <label>Stage 2</label>
          </div>
          <div class="col-3">
            <label>Pressure Vessel ID:</label>
          </div>
          <div class="col-3">
            <label>Permeate Conductivity:</label>
          </div>
        </div>
        <div class="row" *ngFor="let row of stage2PvIds">
          <div class="col-1"></div>
          <div class="col-3">
            <div class="m-2">
              <input type="text" class="form-control border border-dark" name="{{ row }}" placeholder="{{ row }}"
                disabled="true" />
            </div>
          </div>
          <div class="col-3">
            <div class="m-2">
              <input type="text" id="permCond{{ row }}" name="permCond{{ row }}" [(ngModel)]="permCondValues[row]"
                class="form-control border border-dark" />
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="stage3PvIds.length != 0">
        <div class="row" style="font-weight: bold;">
          <div class="col-1">
            <label>Stage 3</label>
          </div>
          <div class="col-3">
            <label>Pressure Vessel ID:</label>
          </div>
          <div class="col-3">
            <label>Permeate Conductivity:</label>
          </div>
        </div>
        <div class="row" *ngFor="let row of stage3PvIds">
          <div class="col-1"></div>
          <div class="col-3">
            <div class="m-2">
              <input type="text" class="form-control border border-dark" name="{{ row }}" placeholder="{{ row }}"
                disabled="true" />
            </div>
          </div>
          <div class="col-3">
            <div class="m-2">
              <input type="text" id="permCond{{ row }}" name="permCond{{ row }}" [(ngModel)]="permCondValues[row]"
                class="form-control border border-dark" />
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="tableData"></div>
      <div class="row" *ngIf="
          tableData.length != 0
        ">
        <div class="col-2"></div>

        <div class="col-2" style="text-align: right">
          <button type="submit" class="btn custom-buttons-btn mt-3">Create</button>
        </div>
        <div class="col-2" style="text-align: left">
          <button type="button" class="btn custom-buttons-btn mt-3" (click)="reloader()">
            Reset
          </button>
        </div>
      </div>
    </div>

    <div style="min-height: 15px;"></div>

    <div class="row" *ngIf="tableData && tableData == 0">
      <div class="col-2"></div>
      <div class="col-8" style="font-size: large;">
        <label>✱</label>
        <br />
        <label>Initial conductivity profiles must be added through Import
          Conductivity Profiles.</label>
        <br />
        <label>The template used for conductivity profile can be found under
          Resources.</label>
      </div>
      <br />
      <div class="row"></div>
      <div class="col-2"></div>
      <div class="col-6">
        <button id="import-condprof" class="btn custom-buttons-btn m-2"
          [routerLink]="['/conductivityprofile/import-conductivityprofile']">
          Go to Import Conductivity Profiles
        </button>

        <button id="resources" class="btn custom-buttons-btn m-2" [routerLink]="['/component/resources']">
          Go to Resources
        </button>
      </div>
    </div>
  </form>
</div>